import React, { useState } from 'react';
import SubmitButton from '../submit-button/submit-button';
import InputField from '../input-field/input-field';
import AuthPanel from '../auth-panel/auth-panel';
import { validatePassword } from '../../helpers/validate-helper';

export default function ChangePassword() {
  const [continueButtonDisabled, setContinueButtonDisabled] = useState(true);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [newPasswordValidation, setNewPasswordValidation] = useState('');
  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState('');

  function onNewPasswordChange(e) {
    const value = e.target.value;
    setNewPassword(value);

    if (!value) {
      setNewPasswordValidation('Campo obrigatório.');
      setContinueButtonDisabled(true);
    } else if (value.length < 8) {
      setNewPasswordValidation('Senha deve conter no mínimo 8 caracteres.');
      setContinueButtonDisabled(true);
    } else {
      const passwordValidation = validatePassword(value);
      if (!passwordValidation.isValid) {
        setNewPasswordValidation(passwordValidation.message);
        setContinueButtonDisabled(true);
      } else {
        setNewPasswordValidation('');
        // Check if confirm password matches
        if (confirmNewPassword && value !== confirmNewPassword) {
          setConfirmPasswordValidation('As senhas não coincidem.');
          setContinueButtonDisabled(true);
        } else if (confirmNewPassword) {
          setConfirmPasswordValidation('');
          setContinueButtonDisabled(false);
        }
      }
    }
  }

  function onConfirmPasswordChange(e) {
    const value = e.target.value;
    setConfirmNewPassword(value);

    if (!value) {
      setConfirmPasswordValidation('Campo obrigatório.');
      setContinueButtonDisabled(true);
    } else if (value !== newPassword) {
      setConfirmPasswordValidation('As senhas não coincidem.');
      setContinueButtonDisabled(true);
    } else {
      setConfirmPasswordValidation('');
      // Only enable if new password is also valid
      if (newPassword && newPassword.length >= 8 && validatePassword(newPassword).isValid) {
        setContinueButtonDisabled(false);
      }
    }
  }

  return (
    <AuthPanel message='A senha deve conter pelo menos 8 caracteres, 1 letra maiúscula, 1 minúscula e 1 número.'>
      <div className='login-fieldset' style={{ marginTop: '40px' }}>
        <InputField
          type='password'
          inputId='newPassword'
          label='nova senha'
          placeholder='insira sua nova senha'
          value={newPassword}
          validationMessage={newPasswordValidation}
          onChange={onNewPasswordChange}
        />
      </div>
      <div className='login-fieldset'>
        <InputField
          type='password'
          inputId='confirmNewPassword'
          label='confirme a senha'
          placeholder='confirme sua nova senha'
          value={confirmNewPassword}
          validationMessage={confirmPasswordValidation}
          onChange={onConfirmPasswordChange}
        />
      </div>
      <div className='login-button'>
        <SubmitButton
          variant='primary'
          buttonStyle={{ width: '288px' }}
          value='continuar'
          disabled={continueButtonDisabled}
        />
      </div>
    </AuthPanel>
  );
}
